<ngb-toast
           *ngFor="let toast of toastService.toasts"
           [class]="toast.classname"
           [autohide]="true"
           (click)="handleClick(toast)"
           [delay]="toast.delay || 5000"
           (hidden)="toastService.remove(toast)">
    <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
        <ng-template [ngTemplateOutlet]="asTemplate(toast)"></ng-template>
    </ng-template>

    <ng-template #text>
        <span style="white-space: pre-line">{{ toast.content }}</span>
    </ng-template>
</ngb-toast>